/* Collection strip artwork fitting only. Merchant URLs, image loading and controls stay native. */
(function (root) {
  'use strict';
  function inkBounds(data, width, height) {
    var left = width, right = -1, top = height, bottom = -1;
    for (var y = 0; y < height; y++) for (var x = 0; x < width; x++) {
      var offset = (y * width + x) * 4;
      if (data[offset + 3] > 24 && Math.min(data[offset], data[offset + 1], data[offset + 2]) < 230) {
        left = Math.min(left, x); right = Math.max(right, x);
        top = Math.min(top, y); bottom = Math.max(bottom, y);
      }
    }
    return right >= left ? { w: width, h: height, l: left, t: top, iw: right - left + 1, ih: bottom - top + 1 } : null;
  }
  function fitLogo(bounds, cardWidth, cardHeight, frameWidth, frameHeight) {
    if (!bounds || !cardWidth || !cardHeight || !frameWidth || !frameHeight || !bounds.iw || !bounds.ih) return null;
    var aspect = bounds.iw / bounds.ih;
    // Equal-area optical rule from the existing hero-brand treatment, with hard tile caps.
    var height = Math.max(12, 0.4 * Math.sqrt(cardWidth * cardHeight) / Math.sqrt(aspect));
    height = Math.min(height, cardHeight * 0.5, frameHeight, cardWidth * 0.75 / aspect, frameWidth / aspect);
    var scale = height / bounds.ih, inkWidth = bounds.iw * scale;
    return { scale: scale, inkWidth: inkWidth, inkHeight: height,
      width: bounds.w * scale, height: bounds.h * scale,
      left: (frameWidth - inkWidth) / 2 - bounds.l * scale,
      top: (frameHeight - height) / 2 - bounds.t * scale };
  }
  if (typeof module === 'object' && module.exports) module.exports = { inkBounds: inkBounds, fitLogo: fitLogo };
  if (!root || !root.document || root.bmCollectionStripLogos) return;
  root.bmCollectionStripLogos = true;
  var document = root.document, cache = new Map(), entries = new WeakMap();
  function measure(source) {
    if (!cache.has(source)) cache.set(source, new Promise(function (resolve) {
      var probe = new Image(); probe.crossOrigin = 'anonymous';
      probe.onload = function () {
        var full = { w: probe.naturalWidth, h: probe.naturalHeight, l: 0, t: 0, iw: probe.naturalWidth, ih: probe.naturalHeight };
        try {
          var ratio = Math.min(1, 600 / Math.max(probe.naturalWidth, probe.naturalHeight));
          var width = Math.max(1, Math.round(probe.naturalWidth * ratio)), height = Math.max(1, Math.round(probe.naturalHeight * ratio));
          var canvas = document.createElement('canvas'); canvas.width = width; canvas.height = height;
          var context = canvas.getContext('2d', { willReadFrequently: true });
          context.drawImage(probe, 0, 0, width, height);
          resolve(inkBounds(context.getImageData(0, 0, width, height).data, width, height) || full);
        } catch (error) { resolve(full); }
      };
      // CORS or network failures leave the original non-CORS lazy image and its contain fallback intact.
      probe.onerror = function () { resolve(null); };
      probe.src = source;
    }));
    return cache.get(source);
  }
  function apply(image) {
    var entry = entries.get(image);
    if (!entry || !entry.bounds || !image.isConnected) return;
    var frame = image.closest('.item-collection-img'), card = image.closest('a');
    if (!frame || !card) return;
    var fit = fitLogo(entry.bounds, card.clientWidth, card.clientHeight, frame.clientWidth, frame.clientHeight);
    if (!fit) return;
    // Original artwork remains in flow; its fitted decoration is not a second link.
    var overlay = frame.querySelector('.bm-strip-logo-overlay');
    if (!overlay) {
      overlay = document.createElement('img'); overlay.className = 'bm-strip-logo-overlay';
      overlay.alt = ''; overlay.setAttribute('aria-hidden', 'true'); overlay.setAttribute('role', 'presentation');
      overlay.decoding = 'async'; frame.appendChild(overlay);
    }
    if (entry.overlay !== overlay) {
      entry.overlay = overlay;
      overlay.addEventListener('load', function () { if (entry.source === overlay.getAttribute('src')) apply(image); });
      overlay.addEventListener('error', function () { frame.classList.remove('bm-strip-logo-balanced'); });
    }
    if (overlay.getAttribute('src') !== entry.source) overlay.src = entry.source;
    [['width', fit.width], ['height', fit.height], ['left', fit.left], ['top', fit.top]].forEach(function (pair) {
      overlay.style.setProperty('--bm-strip-image-' + pair[0], pair[1].toFixed(2) + 'px');
    });
    if (overlay.complete && overlay.naturalWidth > 0) frame.classList.add('bm-strip-logo-balanced');
  }
  function init(bar) {
    if (bar.dataset.bmStripLogos) return;
    bar.dataset.bmStripLogos = '1';
    var selector = '.brand-item .item-collection-img > img:not(.bm-strip-logo-overlay)';
    var resize = typeof ResizeObserver === 'function' ? new ResizeObserver(function () { bar.querySelectorAll(selector).forEach(apply); }) : null;
    function scan() {
      bar.querySelectorAll(selector).forEach(function (image) {
        var source = image.getAttribute('data-src') || image.currentSrc || image.src;
        if (!source) return;
        var entry = entries.get(image), frame;
        if (!entry) {
          entry = { bounds: null, source: null }; entries.set(image, entry);
          if (resize) resize.observe(image.closest('a'));
        }
        if (entry.source === source) { apply(image); return; }
        entry.source = source; entry.bounds = null;
        frame = image.closest('.item-collection-img');
        if (frame) frame.classList.remove('bm-strip-logo-balanced');
        // A source/selected-DPR change cannot commit the previous image's bounds.
        measure(source).then(function (bounds) {
          if (entry.source !== source) return;
          entry.bounds = bounds; apply(image);
        });
      });
    }
    scan();
    // The native infinite strip clones items after DOMContentLoaded. Fit those from the same cached bounds.
    var mutations = { childList: true, subtree: true };
    new MutationObserver(scan).observe(bar, mutations);
    if (!resize) root.addEventListener('resize', function () { bar.querySelectorAll(selector).forEach(apply); }, { passive: true });
  }
  function start() {
    document.querySelectorAll('#temp-2026-collection-header .brands-logo-bar').forEach(function (bar) { init(bar); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true }); else start();
  document.addEventListener('shopify:section:load', start);
})(typeof window === 'undefined' ? null : window);
